import { modifyKickOfUserOptions } from "../helpers/modifyErrorData";
import {participantsStore} from "./participantsStore";
// import {cacheService} from "../services/cacheService";

const {setBlockedUser} = participantsStore;

export const BUILD_URL = {
    dataUrl: "https://space-api.pandamr.io/media/dynamic/unity_files/iceWebGl.data.br",
    frameworkUrl: "https://space-api.pandamr.io/media/dynamic/unity_files/iceWebGl.framework.js.br",
    loaderUrl: "https://space-api.pandamr.io/media/dynamic/unity_files/iceWebGl.loader.js",
    codeUrl: "https://space-api.pandamr.io/media/dynamic/unity_files/iceWebGl.wasm.br",
};
export const OTP_INITIAL_VALUE = [false, false, false, false, false, false];

export const PRIVATE_CALL_STATUS = {
    0: "None",
    1: "Invited",
    2: "Connected",
    3: "Accepted",
    4: "Rejected",
};
export const MEDIA_DEVICE_STATUS = {
    enabled: "enabled",
    disabled: "disabled",
    notFound: "notFound",
};

export const WARNING_TYPES = {
    ERROR: "error",
    WARNING: "warning",
    INFO: "info",
    SUCCESS: "success",
};

export const MICROPHONE_STATUS = {
    0: "MUTE",
    1: "UNMUTE",
    2: "FREEZE",
    3: "MUTE_ALL",
};

export const SELECT_OPTION = [
    {
        value: 2,
        visibleMinutes: 2,
        translationName: "minutes"
    },
    {
        value: 10,
        visibleMinutes: 10,
        translationName: "minutes"
    },
    {
        value: 30,
        visibleMinutes: 30,
        translationName: "minutes"
    },
    {
        value: 60,
        visibleMinutes: 1,
        translationName: "hours"
    },
    {
        value: 1440,
        visibleMinutes: 24,
        translationName: "hours"
    }
];

export const ERROR_MAP = {
    "expired_session": {
        redirectPath: "/",
    },
    "guest_does_not_have_permission": {
        modal_title: "“Oops!”",
        modal_message: "Guest does not have permission to perform this action.",
        isModal: true,
        closeable: true,
        callBack: () => {
            setBlockedUser(true);
        },
        redirectPath: "/dashboard",
    },
    "permission_denied": {
        redirectPath: "/dashboard",
    },
    "blocked_user_exception": {
        redirectPath: "/dashboard",
        callBack: () => {
            setBlockedUser(true);
        }
    },
    "user_deactivated": {
        redirectPath: "/",
    },
    "invalid_credentials": {
        redirectPath: "/",
    },
    "email_not_confirm": {
        redirectPath: "/expired-link",
    },
    "user_does_not_have_permission": {
        modal_title: "“Oops!”",
        isModal: true,
        closeable: true,
        callBack: () => {
            setBlockedUser(true);
        }
    },
    "admin_has_blocked": {
        modal_title: "Kick Off",
        sendedText: "",
        isModal: true,
        closeable: true,
        callBack: () => {
            setBlockedUser(true);
        }
    },
    'unity_doesnt_support': {
        modal_title: '“Oops!”',
        isModal: true,
        closeable: true,
        redirectPath: '/dashboard',
    },
    "room_does_not_exist": {
        redirectPath: "/404",
    },
    "connection_lost": {
        modal_title: "Connection was lost!",
        isModal: true,
        connected: false,
        closeable: true,
    },
    "connection_slow": {
        modal_title: 'Slow internet connection',
        isModal: true,
        connected: false,
        closeable: true,
    },
    "user_freezed": {
        modal_title: "Muted",
        isModal: true,
        closeable: true,
        actionBtnOk: true
    },
    "private_call": {
        modal_title: "Private Call",
        isModal: true,
        closeable: true,
        actionBtnOk: true
    },
    404: {
        redirectPath: "/maintenance",
    }
};

export const modifyErrorData = (options)=> {
    const data = {
        "admin_has_blocked": modifyKickOfUserOptions
    }
    return data[options.key] ? {...options, ...data[options.key](options)} : options
}

export const WARNING_OPTIONS = {
  please_login_marketplace: {
    type: WARNING_TYPES.INFO,
  },
  audio_device: {
    type: WARNING_TYPES.ERROR,
  },
  video_device: {
    type: WARNING_TYPES.ERROR,
  },
  empty_ecommerce: {
    type: WARNING_TYPES.WARNING,
  },
  something_went_wrong: {
    type: WARNING_TYPES.WARNING,
  },
  nft_already_owned: {
    type: WARNING_TYPES.WARNING,
  },
  your_purchase_successful: {
    type: WARNING_TYPES.SUCCESS,
  },
  session_expired: {
    type: WARNING_TYPES.ERROR,
  },
  500: {
    type: WARNING_TYPES.ERROR,
    redirectPath: "/maintenance",

  },
  404: {
    type: WARNING_TYPES.ERROR,
    redirectPath: "/maintenance",
  },
  connection_slow: {
    type: WARNING_TYPES.WARNING,
  },
}
